import {
	currentStepAtom,
	isDisabledAtom,
	selectedSubStepAtom,
	selectedValueAtom,
	subStepExistsAtom,
	subStepValuesAtom,
} from '@store/atoms'
import CustomRadioGroup from '@ui/components/CustomRadioGroup'
import { useAtom } from 'jotai'

import React from 'react'
import {
	documentProgressAtom,
} from '@ui/richiesta/stepper/data/store'
import type { RadioOption } from '@ui/richiesta/stepper/state/store'
import { useAppContext } from '@hooks/use-app-context'
import type { SubStepContact } from '@ui/richiesta/stepper/data/steps'

interface ContactProps {
	options: SubStepContact[]
	onSelectSubStep?: (subStepId: number) => void
}
const SelectDocument = ({ options, onSelectSubStep }: ContactProps) => {
	const optionsDocument = (options ?? []).filter((item) => 'documents' in item)

	const [, setIsDisabled] = useAtom(isDisabledAtom)
	const [activeStep] = useAtom(currentStepAtom)
	const [selectedValueMap] = useAtom(selectedValueAtom)
	const selected = selectedValueMap[activeStep] ?? '' //es step 1 -scelta 2 (allega documenti)
	const [selectedSubStep] = useAtom(selectedSubStepAtom) ///ACTION
	const [, setSubStepExists] = useAtom(subStepExistsAtom)

	const [subStepValues, setSubStepValues] = useAtom(subStepValuesAtom)
	const subStepKey = `${activeStep}-${selectedSubStep}` // chiave unica per questo substep

	const [documentProgress] = useAtom(documentProgressAtom)
	

	// mappiamo le option aggiungendo la proprietà `disabled qunsoil relatiovo do è stato caricato`
	const mappedOptions: RadioOption[] = optionsDocument.map((opt) => ({
		...opt,
		disabled: !!documentProgress[Number(opt.value)]?.completed,
		loaded: !!documentProgress[Number(opt.value)]?.completed,
	}))

	//TODO se il doc è stato caricato inserire nelel option le due immagini deske mobile sul RADIO BUTTON
	const requiredSubSteps = optionsDocument.filter((i) => i.required === true)

	//es6
	const requiredCompleted = requiredSubSteps.every((sub) => {
		const id = Number(sub.value)
		return documentProgress?.[id]?.completed === true
	})

	const subStepSelected = !!subStepValues[subStepKey]?.radio //true/false
	const subStepId = subStepValues[subStepKey]?.radio //id selesionato

	const subStepIdNum = subStepId ? Number(subStepId) : null //PER TYPESCRIPT

	///DISABILITA IL BUTTON SE

	const canProceed = requiredCompleted || subStepSelected

	React.useEffect(() => {
		setIsDisabled(!canProceed)
		console.log('ttiva')
	}, [canProceed, setIsDisabled])

	/* React.useEffect(() => {
		if (activeDocument || requiredCompleted) {
			setIsDisabled(false)
			return
		}
		setIsDisabled(!subStepSelected)
	}, [activeDocument, requiredCompleted, subStepSelected]) */

	//DISABILITA IL RADIO BUTTON

	React.useEffect(() => {
		if (subStepIdNum === null) return
		if (documentProgress?.[subStepIdNum]?.completed !== true) return

		setSubStepValues((prev) => ({
			...prev,
			[subStepKey]: { ...prev[subStepKey], radio: null },
		}))
	}, [documentProgress, subStepIdNum, subStepKey, setSubStepValues])

	// Trova l’opzione selezionata
	const selectedOption = options.find((o) => o.value === selected)

	// Se l’opzione ha subSteps → segnala al footer @TODO VERIFICA SE SERVE MA IN GNO CASO QUI NON ABBBIAMO SUBSTEPS
	/* React.useEffect(() => {
		setSubStepExists(!!selectedOption?.subSteps)
	}, [selectedOption, setSubStepExists]) */

	//console.log("ARRIVA A SELECT",options,selectedOption)

	const optionalCompleted = documentProgress['3']?.completed
	const showOptionalInfo =
		selectedSubStep === 'selectDocument' &&
		requiredCompleted &&
		!optionalCompleted

	const { state } = useAppContext()

	console.log('DOCUMENTPRGOGRESS',documentProgress)
	//SUBSTEPS DOCUMENTI
	return (
		<div>
			<h2 className='text-(--primary-blue) text-[28px] md:text-[40px] font-semibold pt-2.5 pb-2.5'>
				Seleziona il documento che vuoi caricare
			</h2>

			<div className='min-h-[200px] md:min-h-[421px] md:pt-5 mb-4'>
				<CustomRadioGroup
					name='scelta'
					options={mappedOptions} // <-- qui passiamo le option già "mappate"
					selectedValue={subStepValues[subStepKey]?.radio ?? null}
					minH={'min-h-[57px]'}
					colsDesktop={showOptionalInfo ? 'md:grid-cols-2' : 'md:grid-cols-3'}
					onChange={(value) => {
						const opt = optionsDocument.find((o) => o.value === value)
						if (!opt) return

						setSubStepValues((prev) => ({
							...prev,
							[subStepKey]: { radio: value },
						}))
						setSubStepExists(true)

						if (onSelectSubStep) {
							onSelectSubStep(Number(value))
							//in questo modo il click sul radio aggiorna subito l’atom globale (activeSubStepIdAtom) e il wizard padre sa che deve partire.
						}
					}}
				/>
				{showOptionalInfo && (
					<p>
						Puoi caricarlo ora oppure proseguire e farlo in un secondo momento.
					</p>
				)}
			</div>
		</div>
	)
}
export default SelectDocument
